$(document).ready(function() {
    var countryInput = document.getElementById('awesomplete'),
        countryForm = document.getElementById('find-rep-country-select');
    var postalInput = document.getElementById('find-rep-zip'),
        postalForm = document.getElementById('find-rep-postal');
    var showMoreLink = document.getElementById('show-more-link'),
        showLessLink = document.getElementById('show-less-link');
    var isWidget = document.querySelector('[data-find-rep-widget]') != null;
    var metadataElement = $('*[data-site-function]'),
        itemsShown = parseInt(metadataElement.data('items-shown')),
        siteFunction = metadataElement.data('site-function'),
        siteDivision = metadataElement.data('site-division'),
        currentCountry = metadataElement.data('current-country'),
        currentPostalCode = metadataElement.data('current-postal-code'),
        postalValidationMsg = metadataElement.data('postalcode-validation-msg');

    var getSiteList = OnlyLatestRequestCallback();

    postalInput.autocomplete = 'off';
    countryInput.autocomplete = 'off';
    
    $('#find-rep-country-select').submit(onCountrySelect);
    $('#find-rep-country-select').change(onCountrySelect);
    $('#find-rep-postal').submit(function(event) {
        // do not refresh page
        event.preventDefault();

        if (!validateInputs(true)) {
            return;
        }

        findSites(sitesHandler);
    });
    $('#show-more-link, #show-less-link').click(function(event) {
        event.preventDefault();
        var isExpanded = event.target.id == showMoreLink.id;
        var sites = document.querySelectorAll('.sidebar-cards-grid-item-callout-result');
        sites.forEach(function(s, i) {
            if (i < itemsShown) {
                return;
            }
            isExpanded
                ? $(s).slideDown(300)
                : $(s).slideUp(300);
        });

        if (sites.length <= itemsShown) {
            return;
        }

        if (isExpanded) {
            $(showMoreLink).slideUp(300);
            $(showLessLink).slideDown(300);
            return;
        }

        $(showMoreLink).slideDown(300);
        $(showLessLink).slideUp(300);
    });

    postalInput.addEventListener('keypress', function(event) {
        postalInput.setCustomValidity('');
    });

    function isAvailableCountry(country) {
        return $("#awesomplete option[value='" + country + "']").length > 0;
    }

    // PREFILL geodata if information is available
    (function() {
        if (!currentCountry || currentCountry === '' || !isAvailableCountry(currentCountry)) {
            // Either we don't have country or it's not an available option
            return;
        }
        countryInput.value = currentCountry;

        if (showHidePostalForm()) {
            if (!currentPostalCode || currentPostalCode === '') {
                // Postal code is required, but we don't have one
                return;
            } else {
                postalInput.value = currentPostalCode;
            }
        }

        // Trigger initial search
        findSites(sitesHandler);
    })();

    // Point to Google or Baidu maps
    function address2Link() {
        getMapUrl = function(lat, long) {
            // use google maps by default
            return 'https://google.com/maps/search/' + lat + ',' + long;
        }
        if (currentCountry && currentCountry == 'CN') {
            // China deferred for now due to coordinate offsets
            return;
        }

        addresses = document.querySelectorAll('address');
        addresses.forEach(function(addr) {
            var metadata = $(addr),
                lat = metadata.data('latitude'),
                long = metadata.data('longitude'),
            link = document.createElement('a');
            text = addr.innerHTML;

            addr.innerHTML = '';
            link.href = getMapUrl(lat, long);
            link.target = '_blank';
            link.innerHTML = text;
            addr.appendChild(link);
        });
    }

    function onCountrySelect(event) {
        event.preventDefault();

        if (event.type === 'change') {
            // reset postalcode on country change
            postalInput.value = '';
        }

        findSites(sitesHandler);
        showPostal = showHidePostalForm();
        if (!validateInputs(showPostal)) {
            return;
        }

    }

    function findSites(successCallback) {
        var countryCode = countryInput.value;
        var postalCode = postalInput.value;

        $('.sidebar-cards-grid-item-callout-result, .grid-item-callout-result-wrapper').slideUp(300);
        getSiteList.ajax({
            url: window.location.href,
            type: "POST",
            context: this,
            data: {
                scController: "FindRep", scAction: "GetSiteList", criteria: {
                    CountryCode: countryCode,
                    PostalCode: postalCode,
                    SiteFunction: siteFunction,
                    Division: siteDivision,
                    IsWidget: isWidget
                }
            },
            success: successCallback
        });
    }

    function sitesHandler(res) {
        $("#site-list").replaceWith(res.siteListHtml);
        $("#country-searched").text(res.country.name);
        $("#postalcode-searched").text(res.postalCode);
        $(".postal-result").show();
        if (!res.postalCode || res.postalCode.trim() === '') {
            $(".postal-result").hide();
        }

        address2Link();
        sites = document.querySelectorAll('.sidebar-cards-grid-item-callout-result');
        sites.forEach(function(s, i) {
            if (i < itemsShown) {
                $(s).slideDown(300);
                return;
            }
            $(s).hide();
        });

        $(showMoreLink).hide();
        $(showLessLink).hide();
        if (sites.length > itemsShown) {
            $(showMoreLink).slideDown(300);
        }

        $('.grid-item-callout-result-wrapper').slideDown(300);
    }

    function validateInputs(isPostalVisible) {
        var countryCode = countryInput.value;
        var postalCode = postalInput.value;

        if(!countryForm.reportValidity()) {
            return false;
        }

        if(postalCode && postalCode != "" && postalRegex[countryCode] && !postalRegex[countryCode].test(postalCode)) {
            postalInput.setCustomValidity(postalValidationMsg);
        }

        return isPostalVisible
            ? postalForm.reportValidity()
            : true;
    }

    function showHidePostalForm() {
        if (!(countryInput.value === 'US' || countryInput.value === 'CA')) {
            $('#find-rep-postal').slideUp(300);
            $('.find-rep-form').removeClass('postal-active');
            postalInput.removeAttribute('required');
            postalInput.value = '';
            return false;
        }

        postalInput.setAttribute('required', 'required');
        $('#find-rep-postal').slideDown(300);
        $('.find-rep-form').addClass('postal-active');
        return true;
    }

    // http://download.geonames.org/export/dump/countryInfo.txt
    var postalRegex = {
        AD: /^(?:AD)*(\d{3})$/i,
        AL: /^(\d{4})$/i,
        AM: /^(\d{6})$/i,
        AR: /^[A-Z]?\d{4}[A-Z]{0,3}$/i,
        AS: /96799/i,
        AT: /^(\d{4})$/i,
        AU: /^(\d{4})$/i,
        AX: /^(?:FI)*(\d{5})$/i,
        AZ: /^(?:AZ)*(\d{4})$/i,
        BA: /^(\d{5})$/i,
        BB: /^(?:BB)*(\d{5})$/i,
        BD: /^(\d{4})$/i,
        BE: /^(\d{4})$/i,
        BG: /^(\d{4})$/i,
        BH: /^(\d{3}\d?)$/i,
        BL: /^(\d{5})$/i,
        BM: /^([A-Z]{2}\d{2})$/i,
        BN: /^([A-Z]{2}\d{4})$/i,
        BR: /^\d{5}-\d{3}$/i,
        BY: /^(\d{6})$/i,
        CA: /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i,
        CH: /^(\d{4})$/i,
        CL: /^(\d{7})$/i,
        CN: /^(\d{6})$/i,
        CO: /^(\d{6})$/i,
        CR: /^(\d{5})$/i,
        CU: /^(?:CP)*(\d{5})$/i,
        CV: /^(\d{4})$/i,
        CX: /^(\d{4})$/i,
        CY: /^(\d{4})$/i,
        CZ: /^\d{3}\s?\d{2}$/i,
        DE: /^(\d{5})$/i,
        DK: /^(\d{4})$/i,
        DO: /^(\d{5})$/i,
        DZ: /^(\d{5})$/i,
        EC: /^([a-zA-Z]\d{4}[a-zA-Z])$/i,
        EE: /^(\d{5})$/i,
        EG: /^(\d{5})$/i,
        ES: /^(\d{5})$/i,
        ET: /^(\d{4})$/i,
        FI: /^(?:FI)*(\d{5})$/i,
        FM: /^(\d{5})$/i,
        FO: /^(?:FO)*(\d{3})$/i,
        FR: /^(\d{5})$/i,
        GB: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/i,
        GE: /^(\d{4})$/i,
        GF: /^((97|98)3\d{2})$/i,
        GG: /^((?:(?:[A-PR-UWYZ][A-HK-Y]\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\d[A-HJKPS-UW0-9])\s\d[ABD-HJLNP-UW-Z]{2})|GIR\s?0AA)$/i,
        GL: /^(\d{4})$/i,
        GP: /^((97|98)\d{3})$/i,
        GR: /^(\d{5})$/i,
        GT: /^(\d{5})$/i,
        GU: /^(969\d{2})$/i,
        GW: /^(\d{4})$/i,
        HN: /^([A-Z]{2}\d{4})$/i,
        HR: /^(?:HR)*(\d{5})$/i,
        HT: /^(?:HT)*(\d{4})$/i,
        HU: /^(\d{4})$/i,
        ID: /^(\d{5})$/i,
        IE: /^[A-Z]\d{2}$|^[A-Z]{3}[A-Z]{4}$/i,
        IL: /^(\d{7}|\d{5})$/i,
        IM: /^((?:(?:[A-PR-UWYZ][A-HK-Y]\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\d[A-HJKPS-UW0-9])\s\d[ABD-HJLNP-UW-Z]{2})|GIR\s?0AA)$/i,
        IN: /^(\d{6})$/i,
        IQ: /^(\d{5})$/i,
        IR: /^(\d{10})$/i,
        IS: /^(\d{3})$/i,
        IT: /^(\d{5})$/i,
        JE: /^((?:(?:[A-PR-UWYZ][A-HK-Y]\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\d[A-HJKPS-UW0-9])\s\d[ABD-HJLNP-UW-Z]{2})|GIR\s?0AA)$/i,
        JO: /^(\d{5})$/i,
        JP: /^\d{3}-\d{4}$/i,
        KE: /^(\d{5})$/i,
        KG: /^(\d{6})$/i,
        KH: /^(\d{5})$/i,
        KP: /^(\d{6})$/i,
        KR: /^(\d{5})$/i,
        KW: /^(\d{5})$/i,
        KZ: /^(\d{6})$/i,
        LA: /^(\d{5})$/i,
        LB: /^(\d{4}(\d{4})?)$/i,
        LI: /^(\d{4})$/i,
        LK: /^(\d{5})$/i,
        LR: /^(\d{4})$/i,
        LS: /^(\d{3})$/i,
        LT: /^(?:LT)*(\d{5})$/i,
        LU: /^(?:L-)?\d{4}$/i,
        LV: /^(?:LV)*(\d{4})$/i,
        MA: /^(\d{5})$/i,
        MC: /^(\d{5})$/i,
        MD: /^MD-\d{4}$/i,
        ME: /^(\d{5})$/i,
        MF: /^(\d{5})$/i,
        MG: /^(\d{3})$/i,
        MH: /^969\d{2}(-\d{4})$/i,
        MK: /^(\d{4})$/i,
        MM: /^(\d{5})$/i,
        MN: /^(\d{6})$/i,
        MP: /^9695\d{1}$/i,
        MQ: /^(\d{5})$/i,
        MT: /^[A-Z]{3}\s?\d{4}$/i,
        MV: /^(\d{5})$/i,
        MX: /^(\d{5})$/i,
        MY: /^(\d{5})$/i,
        MZ: /^(\d{4})$/i,
        NC: /^(\d{5})$/i,
        NE: /^(\d{4})$/i,
        NF: /^(\d{4})$/i,
        NG: /^(\d{6})$/i,
        NI: /^(\d{7})$/i,
        NL: /^(\d{4}[A-Z]{2})$/i,
        NO: /^(\d{4})$/i,
        NP: /^(\d{5})$/i,
        NZ: /^(\d{4})$/i,
        OM: /^(\d{3})$/i,
        PF: /^((97|98)7\d{2})$/i,
        PG: /^(\d{3})$/i,
        PH: /^(\d{4})$/i,
        PK: /^(\d{5})$/i,
        PL: /^\d{2}-\d{3}$/i,
        PM: /^(97500)$/i,
        PR: /^00[679]\d{2}(?:-\d{4})?$/i,
        PT: /^\d{4}-\d{3}\s?[a-zA-Z]{0,25}$/i,
        PW: /^(96940)$/i,
        PY: /^(\d{4})$/i,
        RE: /^((97|98)(4|7|8)\d{2})$/i,
        RO: /^(\d{6})$/i,
        RS: /^(\d{6})$/i,
        RU: /^(\d{6})$/i,
        SA: /^(\d{5})$/i,
        SD: /^(\d{5})$/i,
        SE: /^(?:SE)?\d{3}\s\d{2}$/i,
        SG: /^(\d{6})$/i,
        SH: /^(STHL1ZZ)$/i,
        SI: /^(?:SI)*(\d{4})$/i,
        SJ: /^(\d{4})$/i,
        SK: /^\d{3}\s?\d{2}$/i,
        SM: /^(4789\d)$/i,
        SN: /^(\d{5})$/i,
        SO: /^([A-Z]{2}\d{5})$/i,
        SV: /^(?:CP)*(\d{4})$/i,
        SZ: /^([A-Z]\d{3})$/i,
        TC: /^(TKCA 1ZZ)$/i,
        TH: /^(\d{5})$/i,
        TJ: /^(\d{6})$/i,
        TM: /^(\d{6})$/i,
        TN: /^(\d{4})$/i,
        TR: /^(\d{5})$/i,
        TW: /^(\d{5})$/i,
        UA: /^(\d{5})$/i,
        US: /^\d{5}(-\d{4})?$/i,
        UY: /^(\d{5})$/i,
        UZ: /^(\d{6})$/i,
        VA: /^(\d{5})$/i,
        VE: /^(\d{4})$/i,
        VI: /^008\d{2}(?:-\d{4})?$/i,
        VN: /^(\d{6})$/i,
        WF: /^(986\d{2})$/i,
        YT: /^(\d{5})$/i,
        ZA: /^(\d{4})$/i,
        ZM: /^(\d{5})$/i,
        CS: /^(\d{5})$/i
    };
});
